import { IVisaPrepForm } from '../../../types';
export type IVisaPrepFormState = IVisaPrepForm;

export enum VisaPrepFormActionTypes {
  UPDATE_VPI_FIELD = '@@visa/visaPersonalInfo/UPDATE_PI_FIELD',
}

export enum Pages {
  VISA_UNLOCK = 'uni-v-visa-unlock',
  PAGE1 = 'uni-v-step1',
  PAGE1_2 = 'uni-v-step1-part2',
  PAGE2_1 = 'uni-v-step2-part1',
  PAGE2_2 = 'uni-v-step2-part2',
  PAGE2_3 = 'uni-v-step2-part3',
  PAGE2_4 = 'uni-v-step2-part4',
  PAGE2_5 = 'uni-v-step2-part5',
  PAGE2_6 = 'uni-v-step2-part6',
  PAGE2_7 = 'uni-v-step2-part7',
  PAGE2_8 = 'uni-v-step2-part8',
  PAGE3_1 = 'uni-v-step3-part1',
  PAGE3_2 = 'uni-v-step3-part2',
  PAGE3_3 = 'uni-v-step3-part3',
  PAGE3_4 = 'uni-v-step3-part4',
  PAGE3_5 = 'uni-v-step3-part5',
  PAGE4 = 'uni-v-step4',
  PAGE5 = 'uni-v-step5',
  PAGE6 = 'uni-v-step6',
  PAGE7_1 = 'uni-v-step7-part1',
  PAGE7_2 = 'uni-v-step7-part2',
  PAGE7_3 = 'uni-v-step7-part3',
  PAGE8 = 'uni-v-step8',
}
